import axios from 'axios';
import jwt_decode from 'jwt-decode';

import { getJwtToken } from './jwt.services';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API's base URL

const newsletterUnsubscribeService = {
	getNewsletterUnsubscribes: async (newsletterId) => {
		try {
			const jwtToken = getJwtToken();
			const decoded = jwt_decode(jwtToken);
			console.log({ decoded });
			console.log({ jwtToken });
			const apiUrl = `${BASE_URL}/newsletters/unsubscribes/${newsletterId}?username=${decoded.username}`;
			console.log({ apiUrl });
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json', // Adjust the content type if needed
			};
			const response = await axios.get(apiUrl, { headers });
			console.log({
				message: 'got data from the back-end',
				data: response.data,
			});
			return response.data;
		} catch (error) {
			console.error({ message: 'Error in getScripts ', error });
		}
	},
	deleteNewsletterUnsubscribes: async (unsubscribeId, companyId) => {
		try {
			const jwtToken = getJwtToken();
			const apiUrl = `${BASE_URL}/newsletters/unsubscribes/${unsubscribeId}/company/${companyId}`;
			console.log({ apiUrl });
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json', // Adjust the content type if needed
			};
			const response = await axios.delete(apiUrl, { headers });
			console.log({
				message: 'got data from the back-end',
				data: response.data,
			});
			return response.data;
		} catch (error) {
			console.error({ message: 'Error in getScripts ', error });
		}
	},
};
export default newsletterUnsubscribeService;
